import { getSelectedPerson } from 'store/selectedBubble/reducer';
import { useSelector } from 'react-redux';
import { Sprite } from '@inlet/react-pixi';
import { getGlobal } from 'store';
import * as PIXI from 'pixi.js';
import gsap from 'gsap';
import { FC, useEffect, useRef } from 'react';
import { getPersonsList } from 'store/resources';
import { CachedSprites } from 'lib/utils';

const SIZE_ASPECT = 0.9;

interface PersonsProps {
  personsSpritesList: CachedSprites;
}

export const PersonComponent: FC<PersonsProps> = ({ personsSpritesList }) => {
  const currentPersonID = useSelector(getSelectedPerson);
  const personsList = useSelector(getPersonsList);
  const { height, width } = useSelector(getGlobal);

  const personRef = useRef<PIXI.Sprite>(null);

  const currentPerson = personsSpritesList[currentPersonID] || { height, width };

  // SIZE PARAMS
  const imageAspect = currentPerson.height / currentPerson.width;
  const spriteHeight = height * SIZE_ASPECT;
  const spriteWidth = spriteHeight / imageAspect;
  const spriteScale: [number, number] =
    personsList[currentPersonID]?.position === 'left' ? [0, 0] : [-1, 0];

  // POS PARAMS
  const isLeft = personsList[currentPersonID]?.position === 'left';
  const startSpriteX = isLeft ? -width : width + spriteWidth;
  const spriteX = isLeft ? 0 : width / 2 + spriteWidth;
  const spriteY = height * (1 - SIZE_ASPECT);

  useEffect(() => {
    if (currentPerson.texture) {
      gsap.to(personRef.current, {
        x: startSpriteX,
        duration: 0,
      });
      const anim = gsap.to(personRef.current, {
        x: spriteX,
        duration: 0.5,
      });

      return () => {
        anim.pause();
      };
    }
  }, [currentPerson.texture]);

  return !currentPerson.texture ? null : (
    <Sprite
      key={currentPerson.texture.textureCacheIds[0]}
      texture={currentPerson.texture}
      scale={spriteScale}
      x={spriteX}
      y={spriteY}
      height={spriteHeight}
      width={spriteWidth}
      ref={personRef}
    />
  );
};
